// extracted by mini-css-extract-plugin
module.exports = {"textEditorWrapper":"textEditor_textEditorWrapper__gTjYr"};